module.exports = __webpack_public_path__ + "img/renno.b97ac90e.svg";